const ARROW_KEYS = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']);

function normalizedCellValue(value) {
    return value === null || value === undefined ? '' : String(value);
}

function shouldNavigateFromInput(key, value, selectionStart, selectionEnd) {
    if (!ARROW_KEYS.has(key)) return false;
    if (key === 'ArrowUp' || key === 'ArrowDown') return true;

    const text = normalizedCellValue(value);
    if (!Number.isInteger(selectionStart) || !Number.isInteger(selectionEnd)) return true;

    if (selectionStart !== selectionEnd) {
        return selectionStart === 0 && selectionEnd === text.length;
    }
    return key === 'ArrowLeft'
        ? selectionStart === 0
        : selectionEnd === text.length;
}

function adjacentCell(lineIds, dates, lineId, date, key) {
    if (!ARROW_KEYS.has(key)) return null;
    const rows = Array.isArray(lineIds) ? lineIds.map(String) : [];
    const columns = Array.isArray(dates) ? dates.map(String) : [];
    const rowIndex = rows.indexOf(String(lineId));
    const columnIndex = columns.indexOf(String(date));
    if (rowIndex < 0 || columnIndex < 0) return null;

    const rowOffset = key === 'ArrowUp' ? -1 : key === 'ArrowDown' ? 1 : 0;
    const columnOffset = key === 'ArrowLeft' ? -1 : key === 'ArrowRight' ? 1 : 0;
    const targetRowIndex = rowIndex + rowOffset;
    const targetColumnIndex = columnIndex + columnOffset;
    if (
        targetRowIndex < 0
        || targetRowIndex >= rows.length
        || targetColumnIndex < 0
        || targetColumnIndex >= columns.length
    ) return null;

    return {
        lineId: rows[targetRowIndex],
        date: columns[targetColumnIndex]
    };
}

module.exports = {
    adjacentCell,
    shouldNavigateFromInput
};
